import { Helmet } from "react-helmet-async";

import { keyFingerprintSections } from "../config/keys";
import { siteConfig } from "../config/site";

export function KeysPage() {
  return (
    <>
      <Helmet>
        <title>Keys · {siteConfig.name}</title>
        <meta
          name="description"
          content={`${siteConfig.name} key and certificate fingerprints.`}
        />
      </Helmet>

      <section className="space-y-6 pb-8">
        <div className="space-y-3">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            keys
          </p>
          <h1 className="font-display text-4xl tracking-tight sm:text-5xl">
            Fingerprints (hilariously thorough)
          </h1>
          <p className="max-w-3xl text-muted-foreground">
            Signing keys, update keys, cert chains, and current TLS cert fingerprints for
            key.store domains.
          </p>
        </div>
      </section>

      <section className="space-y-10 border-t border-border/60 py-10">
        {keyFingerprintSections.map((section) => (
          <div key={section.id} className="space-y-4">
            <div className="space-y-2">
              <h2 className="font-display text-2xl tracking-tight">{section.title}</h2>
              <p className="text-sm text-muted-foreground">{section.description}</p>
            </div>

            <div className="overflow-x-auto rounded-2xl border border-border/60">
              <table className="min-w-full border-collapse text-sm">
                <thead className="bg-muted/30 text-left">
                  <tr>
                    <th className="px-4 py-3 font-medium">Name</th>
                    <th className="px-4 py-3 font-medium">Scope</th>
                    <th className="px-4 py-3 font-medium">Fingerprint</th>
                    <th className="px-4 py-3 font-medium">Algorithm</th>
                    <th className="px-4 py-3 font-medium">Source</th>
                  </tr>
                </thead>
                <tbody>
                  {section.records.map((record) => (
                    <tr key={`${section.id}-${record.name}-${record.scope}`} className="border-t border-border/60 align-top">
                      <td className="px-4 py-3">
                        <p className="font-medium">{record.name}</p>
                        {record.note ? (
                          <p className="mt-1 text-xs text-muted-foreground">{record.note}</p>
                        ) : null}
                      </td>
                      <td className="px-4 py-3 font-mono text-xs sm:text-sm">{record.scope}</td>
                      <td className="px-4 py-3 font-mono text-xs sm:text-sm">
                        <p className="text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
                          {record.fingerprintLabel}
                        </p>
                        <p>{record.fingerprint}</p>
                      </td>
                      <td className="px-4 py-3 font-mono text-xs sm:text-sm">{record.algorithm}</td>
                      <td className="px-4 py-3 font-mono text-xs sm:text-sm">{record.source}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {section.verifyCommand ? (
              <p className="text-xs text-muted-foreground">
                Verify: <code>{section.verifyCommand}</code>
              </p>
            ) : null}
          </div>
        ))}
      </section>
    </>
  );
}
